import { v4 as uuidv4 } from 'uuid';

export const getDeliveryAddressStructure = (address) => {
  const { id, address1, address2, town, country, postcode, region, location: { latitude, longitude }, label, deliveryInstructions, phoneNumber } = address;
  return {
    address: {
      id,
      uuid: uuidv4(),
      address1,
      address2,
      town,
      country,
      region,
      location: {
        lat: latitude,
        long: longitude,
      },
      postcode,
      label,
    },
    instructions: {
      phoneNumber,
      deliveryInstructions,
    },
    label
  };
};
